import './styles.scss';
import { ScoreboardTeam } from 'shared/types/team';

type Props = {
  team: ScoreboardTeam;
};

const ScoreboardTeamLi = ({ team }: Props) => {
  const progressPercentage = Math.min(
    (team.session_total / team.session_goal) * 100,
    100
  );

  return (
    <li className="team-rank">
      <span className="team-name">{team.team_name}</span>

      <div className="progress-bar-container">
        <div
          className="progress-bar-fill"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      <div className="team-stats">
        <span className="stat-total">{team.session_total}</span>
        <span className="stat-divider">/</span>
        <span className="stat-goal">{team.session_goal}</span>
      </div>
    </li>
  );
};

export default ScoreboardTeamLi;
